module.exports = __webpack_public_path__ + "static/img/97.395931b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/97.png
// module id = 2NML
// module chunks = 0